import { PropertyValueIcon } from "../../../atoms/icons/property-value";
import React from "react";

export const PropertyValue = ({ price }) => {
  return (
    <div className="irq-nav-wrapper">
      <PropertyValueIcon className="margin-right" fill="white" />
      <span className="top-stats-text">Property Value:</span>
      <div className="margin-left">
        <span className="large"> $</span>
        <span className="large bold">{parseFloat(price).toLocaleString()}</span>
      </div>
    </div>
  );
};
